import React from 'react';
import {AppleFilled, AndroidFilled} from '@ant-design/icons';
import {APP_STORE_URL, GOOGLE_PLAY_URL} from '../../content/appLinks';
import './AuthPages.css';

/**
 * Wspólne zakończenie ekranów, na które prowadzą linki z e-maili.
 *
 * Strona nie ma logowania, więc jedyne sensowne „co dalej" to powrót do
 * aplikacji, a dla osób bez niej na telefonie linki do sklepów.
 */
function BackToApp({text = 'Dalsze kroki wykonasz w aplikacji na telefonie.'}) {
  return (
    <div className="auth-backapp">
      <p className="auth-backapp-text">{text}</p>
      <div className="auth-backapp-stores">
        <a className="auth-backapp-store" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <AppleFilled /> App Store
        </a>
        <a className="auth-backapp-store" href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer">
          <AndroidFilled /> Google Play
        </a>
      </div>
    </div>
  );
}

export default BackToApp;
